export default {
  home: 'Accueil',
  lessons: 'Mes leçons',
  add: 'Ajouter',
  notifications: 'Notifications',
  profile: 'Profil',
};
